import { render, staticRenderFns } from "./perfil-navbar-skeleton.vue?vue&type=template&id=8a65f8aa&scoped=true&"
import script from "./perfil-navbar-skeleton.component.ts?vue&type=script&lang=ts&"
export * from "./perfil-navbar-skeleton.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a65f8aa",
  null
  
)

export default component.exports